<template>
  <v-app style="background-image: linear-gradient(-150deg, #FFFFFF, #FFFFFF);">
    <v-container v-if="roleType === 'Administrator'" fluid grid-list-md text-xs-center>
      <v-layout row wrap>
        <!-- State Franchise -->
        <v-flex xs12 md1 sm1></v-flex>
        <v-flex xs12 md2 sm2>
          <v-card flat dark style="background-image: linear-gradient(-150deg, #64f5a9, #2d93ea);">
            <v-layout>
              <v-flex xs10 class="text-lg-left">
                <h6>Users</h6>
                <h3>{{dashboardData.user}}</h3>
              </v-flex>
              <v-flex xs2>
                <v-icon size="30" color="white">account_box</v-icon>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <!-- Supreme Franchise -->
        <v-flex xs12 md2 sm2>
          <v-card flat dark style="background-image: linear-gradient(-150deg, #64f5a9, #2d93ea);">
            <v-layout>
              <v-flex xs10 class="text-lg-left">
                <h6>Tour Theme</h6>
                <h3>{{dashboardData.theme}}</h3>
              </v-flex>
              <v-flex xs2>
                <v-icon size="30" color="white">filter_vintage</v-icon>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <!-- Master Franchise -->
        <v-flex xs12 md2 sm2>
          <v-card flat dark style="background-image: linear-gradient(-150deg, #64f5a9, #2d93ea);">
            <v-layout>
              <v-flex xs10 class="text-lg-left">
                <h6>Destination</h6>
                <h3>{{dashboardData.domestic}}</h3>
              </v-flex>
              <v-flex xs2>
                <v-icon size="30" color="white">compass_calibration</v-icon>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>


        <v-flex xs12 md2 sm2>
          <v-card flat dark style="background-image: linear-gradient(-150deg, #64f5a9, #2d93ea);">
            <v-layout>
              <v-flex xs10 class="text-lg-left">
                <h6>Destination</h6>
                <h3>{{dashboardData.international}}</h3>
              </v-flex>
              <v-flex xs2>
                <v-icon size="30" color="white">compass_calibration</v-icon>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <!-- Franchise -->
        <v-flex xs12 md2 sm2>
          <v-card flat dark style="background-image: linear-gradient(-150deg, #64f5a9, #2d93ea);">
            <v-layout>
              <v-flex xs10 class="text-lg-left">
                <h6>Tour Package</h6>
                <h3>{{dashboardData.package}}</h3>
              </v-flex>
              <v-flex xs2>
                <v-icon size="30" color="white">business_center</v-icon>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12 md1 sm1></v-flex>
      </v-layout>

    </v-container>
    <div v-if="roleType === 'Customer'">
      <CustomerDashboard/>
    </div>
  
  </v-app>
</template>

<script>

import Vue from "vue";
import config from "../../config.json";
import CustomerDashboard from "../Dashboard/Customer/customerDashboard";

export default {
  components: {
    CustomerDashboard
  },

  data() {
    return {
      roleType: sessionStorage.roles,

      dashboardData: null
    };
  },

  methods: {
    getData() {
      this.axios
        .get(config.API + "AdminDashboard", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.dashboardData = res.data;
        })
        .catch(err => {
        });
    }
  },

  created() {
    this.getData();
  }
};
</script>

<style scoped>
.v-card {
  border-radius: 6px !important;
  padding: 25px;
  letter-spacing: 0.5px;
}
.v-sheet--offset {
  top: -50px;
  position: relative;
}
</style>
